import React from 'react';
import { Card, CardBody, CardTitle, Row } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Colxx
} from '../../../../../components/common/CustomBootstrap';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import Visitor from '../../../../../containers/pages/visitor';

const Conversations = ({ selectedChat, StopFacebookChat, ResumeFacebookChat }) => {
    return (
        <Row>
            <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-6">
                <CardTitle>Chat</CardTitle>{' '}
                <Card style={{ height: 500, overflow: 'scroll' }}>
                    <CardBody>
                        <div className="scroll  ">
                            {selectedChat && (
                                <PerfectScrollbar
                                    className="scroll box-height"
                                    option={{ suppressScrollX: true, wheelPropagation: true }}
                                >
                                    <div>
                                        {selectedChat.messages != null &&
                                            selectedChat.messages.length > 0 &&
                                            selectedChat.messages.map((item, index) => {
                                                // const sender = allContacts.find(x => x.id === item.sender);
                                                return (
                                                    <ChatMessage
                                                        key={index}
                                                        sender={item.sender}
                                                        item={item}
                                                        avatar={selectedChat.avatar}
                                                        colors={selectedChat.colours}
                                                    />
                                                );
                                            })}
                                    </div>
                                </PerfectScrollbar>
                            )}
                        </div>
                    </CardBody>
                </Card>
            </Colxx>

            <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-6">
                <CardTitle>Visitor</CardTitle>{' '}
                <Card style={{ height: 500, overflow: 'scroll' }}>
                    <CardBody>
                        {selectedChat && selectedChat.visitor != null && (
                            <Visitor item={selectedChat}
                                StopFacebookChat={StopFacebookChat}
                                ResumeFacebookChat={ResumeFacebookChat}
                                quickReplyTemplates={[]}
                                clickedLinks={selectedChat.clickedLinks !== undefined ?
                                    selectedChat.clickedLinks : undefined}
                            />
                        )}
                    </CardBody>
                </Card>
            </Colxx>
        </Row>)
};

export default Conversations;